import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Box } from '@cp/ds/src/components/box';
import { Link } from '@cp/ds/src/components/link';
import { ClientPatronageViewModel } from '@common/model/admin/clientPatronage/view';
import { SxProps } from '@cp/ds';
import { Checker } from '@cp/ds/src/components/checker';
import { IHistoryItem, useHistoryItems } from '../../model';

export interface HistoryProps {
  data: ClientPatronageViewModel;
  sx?: SxProps;
}

export const History: React.FC<HistoryProps> = ({ data, sx }) => {
  const [isCollapsed, setCollapsed] = React.useState(true);
  const { items, stageToHistoryItem } = useHistoryItems({ data });

  return (
    <Stack direction="column" gap={0.5} sx={sx}>
      {!isCollapsed && (
        <Box>
          <Link onClick={() => setCollapsed(true)} size="small">
            Свернуть
          </Link>
        </Box>
      )}

      {(isCollapsed ? ([stageToHistoryItem[data.stage]].filter(Boolean) as IHistoryItem[]) : items).map(({ label, completedAt }) => (
        <Stack direction="row" key={label} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
          <Checker checked={Boolean(completedAt)} size="small" variant="checkbox" />
          <Typography sx={{ ml: '6px', mr: 'auto' }} variant="caption bold">
            {label}
          </Typography>
          {completedAt ? (
            <Typography sx={{ color: 'gray' }} variant="small text">
              {completedAt}
            </Typography>
          ) : null}
        </Stack>
      ))}

      {isCollapsed && (
        <Box>
          <Link component="span" onClick={() => setCollapsed(false)} role="button" size="small">
            Подробнее
          </Link>
        </Box>
      )}
    </Stack>
  );
};
